/** @jsx jsx */
import { jsx, useTheme } from '@emotion/react';

import * as React from 'react';

// CDS
import { Typography2 } from '@coursera/cds-core';

import { getTranslatedProductName } from 'bundles/browse/utils';
import { isSearchTheme } from 'bundles/search-common/searchTheme';

type Props = {
  productTypeName?: string;
};

const ProductTypePill: React.FC<Props> = ({ productTypeName }) => {
  const theme = useTheme();
  if (!isSearchTheme(theme)) {
    throw new Error(
      'ProductTypePill can only be used in the context of a SearchTheme. Wrap this component with a ThemeProvider.'
    );
  }
  const productNameTranslated = getTranslatedProductName(productTypeName);

  return (
    <div className="rc-ProductTypePill" css={theme.productTypePill}>
      <Typography2 component="span" className="withoutGradient pillContainer">
        {productNameTranslated}
      </Typography2>
    </div>
  );
};

export default ProductTypePill;
